import { render, staticRenderFns } from "./multidimensionalBar.vue?vue&type=template&id=d8dd2704&scoped=true&"
import script from "./multidimensionalBar.vue?vue&type=script&lang=js&"
export * from "./multidimensionalBar.vue?vue&type=script&lang=js&"
import style0 from "./multidimensionalBar.vue?vue&type=style&index=0&id=d8dd2704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dd2704",
  null
  
)

export default component.exports